import { isFunction } from "lodash";
import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UseMarkChatRoomAsReadProps {
  onSuccess?: () => void;
}

export const useMarkChatRoomAsRead = ({
  onSuccess,
}: UseMarkChatRoomAsReadProps = {}) => {
  const { mutateAsync: markChatRoomAsRead } = useMutation(
    ({ uuid }: { uuid: string }) =>
      reactQueryPost(
        internalApi.chatRooms.markAllAsRead({
          uuid,
        }),
      ),
    {
      onSuccess: () => {
        isFunction(onSuccess) && onSuccess();
      },
      onError: (err: { message: string }) => {
        console.error(err.message);
      },
    },
  );

  return { markChatRoomAsRead };
};
